import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
import axios from '../../../utils/axios-util'
import {
  INVALID_PASSWORD_REGEX,
  VALID_EMAIL_REGEX,
  VALID_NAME,
  VALID_WEBHOOK_URL_PORT_REGEX,
  VALID_WEBHOOK_URL_REGEX,
  VAILD_NOTES_REGEX,
} from '../../../../../server/src/shared/regex'
import { IANA_TLDS } from '../../../../../server/src/shared/ianaTlds'

export function validatePassword(value) {
  const passwordLength = value && value.length
  if (!passwordLength) {
    return <Message id="validate.password.required" />
  } else if (passwordLength < 8) {
    return <Message id="validate.password.atleast" />
  } else if (passwordLength > 20) {
    return <Message id="validate.password.atmost" />
  } else if (value.indexOf(' ') !== -1) {
    return <Message id="validate.password.notspaces" />
  } else if (INVALID_PASSWORD_REGEX.test(value)) {
    return <Message id="validate.password.password" />
  }

  return undefined
}

export async function validateAccountEmail(email, csrf) {
  const emailValidation = 'validate.email.valid';
  const applicationJSON = 'application/json';
  if (!VALID_EMAIL_REGEX.test(email)) {
    return { err: emailValidation }
  }
  //adding the tlds validation because of https://paypal.slack.com/archives/C3BSQ703T/p1717609010252439?thread_ts=1717595460.007779&cid=C3BSQ703T
  const domain = email.split('@')[1]
  if (!domain) {
    return { err: emailValidation }
  }

  // Extract the TLD from the domain
  const parts = domain.split('.')
  const tld = parts[parts.length - 1].toUpperCase()

  // Check if the TLD is in the list of valid TLDs
  if (!IANA_TLDS.includes(tld)) {
    return { err: emailValidation }
  }
  const urlValidateEmail = '/dashboard/api/accounts/create/available'
  const formEmail = { email }
  try {
    const response = await axios({
      method: 'post',
      url: urlValidateEmail,
      data: formEmail,
      headers: {
        Accept: applicationJSON,
        'Content-Type': applicationJSON,
        'x-csrf-token': csrf,
      },
      responseType: 'json',
      contentType: applicationJSON,
    })
    if (response && response.data?.isExisted) {
      return { err: 'validate.email.alreadyexist' }
    }

    return { res: 'validate.email.available' }
  } catch (error) {
    return { err: 'validate.email.error', statusCode: error?.request?.status }
  }
}

export function validateAccountPassword(password) {
  if (password) {
    const passwordLength = password.length
    if (passwordLength < 8) {
      return { err: 'validate.password.atleast' }
    } else if (password.indexOf(' ') !== -1) {
      return { err: 'validate.password.notspaces' }
    } else if (INVALID_PASSWORD_REGEX.test(password)) {
      return { err: 'validate.password.password' }
    }

    return {}
  }

  return { err: 'validate.password.required' }
}

export function validateBalance(value) {
  const floatValue = parseFloat(value)
  if (floatValue > 100000) {
    return <Message id="validate.balance.length" />
  }
  return null
}

export function validateUserNotes(value) {
  return !VAILD_NOTES_REGEX.test(value)
    ? { err: 'validate.notes.specialcharacters' }
    : {}
}

export function validateWebhookURL(value) {
  if (!value) {
    return <Message id="validate.webhookURL.required" />
  } else if (value.indexOf('https') === -1) {
    return <Message id="validate.webhookURL.validHttps" />
  } else if (VALID_WEBHOOK_URL_PORT_REGEX.test(value)) {
    // RegEx to check if port number is specified in the URL or not.
    // It will return true if there is a number after : in the URL
    if (value.indexOf(':443') === -1) {
      return <Message id="validate.webhookURL.validPort" />
    }
  } else if (!VALID_WEBHOOK_URL_REGEX.test(value)) {
    return <Message id="validate.webhookURL.validUrl" />
  }
  return undefined
}

export function validateAccountName(value) {
  return !!VALID_NAME.test(value)
}

export function validateName(name) {
  if (!name || name.trim() === '') {
    return 'Please enter a name'
  } else if (!VALID_NAME.test(name)) {
    return 'Please enter only letters or spaces.'
  }

  return null
}
